import {
  Component,
  Input,
  output,
  inject,
  Type,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { CheckboxChangeEvent, CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { DialogService } from 'primeng/dynamicdialog';
import { DIALOG_CONFIG_FOR_FILTERS } from '@bindoc-projects/util-lib/ui';
import { BD_DIALOG_SERVICE_PROVIDER } from '@bindoc-projects/ui-lib/dialog/ui';

@Component({
  selector: 'kost-data-import-new-target-terms-and-conditions',
  template: `
    <div class="flex flex-row gap-2 items-center">
      <p-checkbox
        [ngModel]="acceptedTermsAndConditions"
        (onChange)="onTosAgreementChange($event)"
        [binary]="true"
      ></p-checkbox>
      <div>
        <span i18n>Ich/wir akzeptiere/n die </span>
        <p-button
          severity="primary"
          variant="text"
          (click)="openTermsAndConditionDialog()"
          i18n
        >
          Allgemeinen Geschäftsbedingungen
        </p-button>
        <span i18n
          >für die Softwarelösungen der BinDoc GmbH in der Version vom
        </span>
        <span>{{ config.tosDate | date: 'dd.MM.yyyy' }}</span>
        <span i18n> und stimme/n der beschriebenen Datennutzung zu.</span>
      </div>
    </div>
  `,
  imports: [DatePipe, CheckboxModule, FormsModule, Button],

  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [BD_DIALOG_SERVICE_PROVIDER],
})
export class VirtualClinicKostNewTermsAndConditionsComponent {
  private readonly _dialogService = inject(DialogService);

  @Input()
  public config: {
    dialog: Type<unknown>;
    tosDate: Date;
  };

  @Input()
  public acceptedTermsAndConditions: boolean;

  public readonly acceptedTermsAndConditionsChange = output<boolean>();

  public openTermsAndConditionDialog(): void {
    this._dialogService.open(this.config.dialog, {
      ...DIALOG_CONFIG_FOR_FILTERS,
      header: $localize`Allgemeine Geschäftsbedingungen für die Verarbeitung der Struktur- und Leistungsdaten`,
    });
  }

  public onTosAgreementChange(event: CheckboxChangeEvent): void {
    this.acceptedTermsAndConditionsChange.emit(event.checked);
  }
}
